import PropTypes from 'prop-types';
import React from 'react'
import { Link } from 'react-router-dom'

import { TextLoader } from '~/components'


export default class extends React.Component {
    static propTypes = {
		questions: PropTypes.array.isRequired,
		fetching: PropTypes.bool
	};

    render() {

		return (

			<div>
				{ this.props.fetching
					? <TextLoader />
					: <div>
		            	{ this.props.questions.map( question => {
							return <div className="side-tab question-tab" key={'question-' + question.uniqueID}>
								<p>
									<Link to={question.link}>
										{ question.title }
									</Link>
								</p>
							</div>
						}) }
					</div>
				}
			</div>

		)

	}
}



// WEBPACK FOOTER //
// ./src/js/views/Community/SideBarRight/Sidebar-Questions.jsx